import PropTypes from 'prop-types';
import {get as _get, has as _has, isEmpty as _isEmpty} from 'lodash';

import {addHasMatchIdToStructure} from '@utils/eventObject';
import {convertToInt} from '@utils/helpers';
import {getCompetitorsNameFromEvent} from '@utils/competitorName';
import {COMPETITOR_NOT_DEFINED_BOTH} from '@constants/variables';

/**
 * Get header title parameters to render event title
 *
 * @param {Object} event
 *
 * @returns {{
 *          competitorsIds:
 *              (
 *                  null|
 *                  {
 *                      homeCompetitorId: (null|number)
 *                      awayCompetitorId: (null|number)
 *                  }
 *              )
 *          title: (string)
 * }}
 */
export const getHeaderTitleParameters = (event) => {
    const headerParams = {
        competitorsIds: null,
        title: null,
    };

    if (_has(event, 'st_event.id')) {
        headerParams['title'] = getHeaderTitleForStageEvent(event.st_event);
    } else {
        const eventDataWithMatchIdFlag = addHasMatchIdToStructure(event);

        headerParams['title'] = getHeaderTitleForEvent(eventDataWithMatchIdFlag);
        headerParams['competitorsIds'] = getComepetitorsIds(eventDataWithMatchIdFlag);
    }

    return headerParams;
};

getHeaderTitleParameters.propTypes = {
    event: PropTypes.object.isRequired,
};

const getHeaderTitleForStageEvent = (stageEvent) => {
    const stage = _get(stageEvent, 'stage', null);

    if (stage) {
        return stage.name;
    }

    return stageEvent.name;
};

/**
 * @param {Object} eventDataWithMatchIdFlag Event with "_hasMatchID" (boolean) flag
 *
 * @returns {string}
 */
const getHeaderTitleForEvent = (eventDataWithMatchIdFlag) => {
    const competitorsTitle = getCompetitorsNameFromEvent(eventDataWithMatchIdFlag);

    /**
     * If both the home competitor and the away competitor are undefined
     */
    if (COMPETITOR_NOT_DEFINED_BOTH === competitorsTitle) {
        // and if there is a description, then display the description
        if (!_isEmpty(eventDataWithMatchIdFlag.description)) {
            return eventDataWithMatchIdFlag.description;
        } else if (!_isEmpty(eventDataWithMatchIdFlag?.external_description)) {
            // display external_description if it exists and there's no description
            return eventDataWithMatchIdFlag.external_description;
        }

        return COMPETITOR_NOT_DEFINED_BOTH;
    }

    return competitorsTitle;
};

getHeaderTitleForEvent.propTypes = {
    eventDataWithMatchIdFlag: PropTypes.object.isRequired,
};

/**
 * Get competitors id to display flags near competitors
 *
 * @param {Object} eventWithMatchFlag
 *
 * @returns {{awayCompetitorId: (null|number), homeCompetitorId: (null|number)}}
 */
const getComepetitorsIds = (eventWithMatchFlag) => {
    let homeCompetitorId = null,
        awayCompetitorId = null;

    if (eventWithMatchFlag._hasMatchID) {
        homeCompetitorId = _get(eventWithMatchFlag, 'sr_event.match.home_competitor.id', null);
        awayCompetitorId = _get(eventWithMatchFlag, 'sr_event.match.away_competitor.id', null);
    } else {
        homeCompetitorId = _get(eventWithMatchFlag, 'sr_event.home_competitor.id', null);
        awayCompetitorId = _get(eventWithMatchFlag, 'sr_event.away_competitor.id', null);
    }

    return {
        homeCompetitorId: homeCompetitorId ? convertToInt(homeCompetitorId) : null,
        awayCompetitorId: awayCompetitorId ? convertToInt(awayCompetitorId) : null,
    };
};

getComepetitorsIds.propTypes = {
    eventWithMatchFlag: PropTypes.object.isRequired,
};
